import Vue from 'vue'
import Router from 'vue-router';
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
import home from '@/components/Home/index';
import overView from '@/components/overView/index';
import project from '@/components/project/list';
import projectInfo from '@/components/project/info';
import projectDetail from '@/components/project/detail';
import pubDetail from '@/components/project/pubDetail';
import dynamics from '@/components/dynamics/index';
import dynamicsDetail from '@/components/dynamics/details';
import pubDetails from '@/components/dynamics/pubDetails';
import donation from '@/components/donation/index';
import pubIndex from '@/components/project/pubIndex';
import pubList from '@/components/dynamics/pubList';
import donationList from '@/components/donation/list';
import donationCopy from '@/components/donation/copy';
import donationCopy2 from '@/components/donation/copy2';
import donationFirst from '@/components/donation/first';
import forum from '@/components/forum/index';
import forumInfo from '@/components/forum/info';
import pubIndex1 from '@/components/project/pubIndex';
import donationList2 from '@/components/donation/list2';
import donationList3 from '@/components/donation/list3';
import search from '@/components/search/index';



Vue.use(Router)

const router = new Router({
  mode: 'history',
  base:'/',
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/overView',
      name: 'overView',
      component: overView
    },
    {
      path: '/project',
      name: 'project',
      component: project
    },
    {
      path: '/projectInfo',
      name: 'projectInfo',
      component: projectInfo
    },
    {
      path: '/projectDetail',
      name: 'projectDetail',
      component: projectDetail
    },
    {
      path: '/pubProjectDetail',
      name: 'pubProjectDetail',
      component: pubDetail
    },
    {
      path: '/dynamics',
      name: 'dynamics',
      component: dynamics
    },
    {
      path: '/details',
      name: 'details',
      component: dynamicsDetail
    },
    {
      path: '/pubDetails',
      name: 'pubDetails',
      component: pubDetails
    },
    {
      path: '/donation',
      name: 'donation',
      component: donation
    },
    {
      path: '/pubProject',
      name: 'pubProject',
      component: pubIndex
    },
    {
      path: '/pubDocument',
      name: 'pubDocument',
      component: pubList
    },
    {
      path: '/donationList',
      name: 'donationList',
      component: donationList
    },
    {
      path: '/largerDonations',
      name: 'largerDonations',
      component: donationCopy
    },
    {
      path: '/largerDonations2',
      name: 'largerDonations2',
      component: donationCopy2
    },
    {
      path: '/first',
      name: 'first',
      component: donationFirst
    },
    {
      path: '/forum',
      name: 'forum',
      component: forum
    },
    {
      path: '/forumInfo',
      name: 'forumInfo',
      component: forumInfo
    },
    {
      path: '/pubPoject',
      name: 'pubPoject',
      component: pubIndex1
    },
    {
      path: '/donationList2',
      name: 'donationList2',
      component: donationList2
    },
    {
      path: '/donationList3',
      name: 'donationList3',
      component: donationList3
    },
    {
      path: '/search',
      name: 'search',
      component: search
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    }
  },
});

router.beforeEach((to, from, next) => {
  if (to.matched.length === 0) { //如果未匹配到路由
    // from.path? next({ path:from.path}) : next('/');   //如果上级也未匹配到路由则跳转主页面，如果上级能匹配到则转上级路由
    next('/')
  } else {
    next(); //如果匹配到正确跳转
  }
});

export default router



// WEBPACK FOOTER //
// ./src/router/index.js